import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';
import { USER_TOKEN } from '../authentication/user-token.util';
import { UserService } from '../services/user/user.service';

@Injectable()
export class AdminApiInterceptor implements HttpInterceptor {
  #userService = inject(UserService);
  #userToken = inject(USER_TOKEN).getValue();
  token = '';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAdminUrl = request.url.startsWith(environment.AdminApiUrl);
    // Attach auth to MS service calls, except:
    //  - requests that already carry an Authorization header, so a caller can opt out
    //  - the Seq log sink, which shares the MS host but takes no auth
    const isMsUrl =
      request.url.startsWith(environment.itoMSUrl) &&
      !request.url.startsWith(environment.seqUrl) &&
      !request.headers.has('Authorization');

    if ((isAdminUrl || isMsUrl) && this.#userService.hasActiveAccount()) {
      return from(this.#userService.acquireAccessToken()).pipe(
        // Attach the access token to the request
        switchMap(accessToken => {
          if(request.url.endsWith('/admin/quote/') && request.method === 'POST'){
            this.token = this.#userToken.jwt
          }
          else{
            this.token = accessToken;
          }
          // Never set Access-Control-Allow-Origin here — it is a *response* header.
          // Sending it on the request makes the preflight ask for a header the
          // Cloudflare worker does not list in Access-Control-Allow-Headers, so the
          // browser blocks the call before it reaches the backend.
          const headers: Record<string, string> = {
            Accept: 'application/json',
            Authorization: `Bearer ${this.token}`
          };
          // FormData bodies need the browser-generated multipart boundary — never force JSON
          if (!(request.body instanceof FormData)) {
            headers['content-type'] = 'application/json';
          }
          if (isAdminUrl) {
            headers['df-api-key'] = sessionStorage.getItem('DfSalesUserApiKey') ?? '';
          }
          const cloned = request.clone({ setHeaders: headers });
          return next.handle(cloned);
        })
      );
    }
    return next.handle(request);
  }
}
